// 상수 옵션 모음
export const encodingOptions = [
  { name: '1', value: 'UTF-8' },
  { name: '2', value: 'EUC-KR' },
];

export const delimiterOptions = [
  { name: 'comma', value: '콤마' },
  { name: 'semicolon', value: '세미콜론' },
  { name: 'pipe', value: '파이프(|)' },
  { name: 'tab', value: '탭(\\t)' },
];

export const geocodingTypeOptions = [
  { name: 'road', value: '도로명' },
  { name: 'parcel', value: '지번' },
];

export const coordSystemOptions = [
  { name: '3857', value: '(3857) WGS 84 / Pseudo-Mercator' },
  { name: '4326', value: '(4326) WGS84 - World Geodetic System' },
  { name: '5174', value: '(5174) Korean 1985 / Modified Central Belt' },
  { name: '5186', value: '(5186) KGD2002 / Central Belt 2010' },
];

export const downloadFormatOptions = [
  { name: 'xlsx', value: '엑셀(xlsx)' },
  { name: 'csv', value: 'comma-separated values' },
];
